export const lightTheme = {
    body: '#F1F2F4',
    background: '#FFFFFF',
    primary: '#00263e',
    secondary: '#2ebeef',
    tertiary: '#2ebeef',
    text: '#00263e',
    contrast: '#ffffff',
    highlight: '#2ebeef',
    active: '#1FDA57',
    disabled: '#8F9AA3',

    white: '#FFFFFF',
    gray: '#43494e',
    black: '#00263e',

    shadow: '#00000029',

    success: '#1FDA57',
    warning: '#fccc00',
    error: '#ff4a4a',
    alert: '#2ebeef',
    promise: '#2ebeef',

    link: '#0086C3',

    chartArray: ['#008ffb', '#00e396', '#feb019', '#775dd0', '#ff4560', '#FF6347', '#32CD32', '#FFD700', '#4169E1', '#FF1493', '#00CED1', '#8A2BE2', '#00FFFF', '#FFA07A'],

    input: {
        background: '#ffffff',
        text: '#00263e',
        highlight: '#E3E6E8',
        active: '#2ebeef',
        disabled: '#F1F2F4',
        disabledText: '#5C6770BF',
    },

    button: {
        background: '#E3E6E8',
        text: '#00263e',
        active: '#00263e',
        activeText: '#ffffff',
        disabled: '#F1F2F4',
        disabledText: '#5C6770BF',
        hover: '#C7CDD1',
        hoverText: '#00263e'
    },
}

export const darkTheme = {
    body: '#1e1e1e',
    background: '#2c2c2c',
    primary: '#080C10',
    secondary: '#96c9ff',
    tertiary: '#07C',
    text: '#eeeeee',
    contrast: '#333333',
    highlight: '#96c9ff',
    active: '#2EEFC0',
    disabled: '#585858',

    white: '#FFFFFF',
    gray: '#a9a9a9',
    black: '#333435',

    shadow: '#121212db',

    success: '#3fd000',
    warning: '#fccc00',
    error: '#ff4141',
    alert: '#24a8ff',
    promise: '#24a8ff',

    link: '#2ebeef',

    input: {
        background: '#2c2c2c',
        text: '#eeeeee',
        highlight: '#4a4a4a',
        active: '#61dafb',
        disabled: '#515151',
        disabledText: '#ffffffcc',
    },

    button: {
        background: '#2c2c2c',
        text: '#eeeeee',
        active: '#07C',
        disabled: '#3a3a3a',
        disabledText: '#7f8490',
        hover: '#4a4a4a',
        hoverText: '#FFF'
    },
}


export const themes = {
    light: lightTheme,
    dark: darkTheme
}